import React, { useState, useEffect } from 'react';
import './NetflixTitle.css';
import netflixSound from './netflix-sound.mp3';
import { useNavigate } from 'react-router-dom';
import logoImage from '../src/images/logo-3.png'; // Update with the path to your logo

const NetflixTitle = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const navigate = useNavigate();

  // This effect runs once, 1 second after the component mounts
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      const audio = new Audio(netflixSound);
      audio.play().catch(error => console.error("Audio play error:", error));
      setIsAnimating(true); // Starts the animation
    }, 1000); // 1-second delay

    // Cleanup function to clear the timer if the component unmounts
    return () => clearTimeout(initialTimer);
  }, []); // The empty array [] ensures this effect runs only once

  // This effect waits for the animation to start, then navigates
  useEffect(() => {
    if (isAnimating) {
      const navigationTimer = setTimeout(() => {
        navigate('/browse');
      }, 4000); // 4-second duration for the animation
      return () => clearTimeout(navigationTimer);
    }
  }, [isAnimating, navigate]);

  return (
    // The onClick handler has been removed from this div
    <div className="netflix-container">
      <img
        src={logoImage}
        alt="Custom Logo"
        className={`netflix-logo ${isAnimating ? 'animate' : ''}`}
      />
    </div>
  );
};

export default NetflixTitle;